export default "__VITE_ASSET__BOtKu3H4__"